<template>
  <div>
    <v-dialog v-model="value" persistent max-width="625px" scrollable>
      <v-card>
        <v-card-title class="headline lighten-2 elevation-3">
          <v-layout row wrap>
            <v-flex xs11 sm11 style="align-self: center">
              <span>
                {{ $t('reports.check_in_and_check_out_report.graphics') }}
              </span>
            </v-flex>
            <v-flex xs1 sm1>
              <v-btn icon @click="close">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <div v-if="delivers.length == 0">{{ textNoInfo }}</div>
                <div div class="chart-container" style="height: 29vh">
                  <canvas
                    id="canvaStdByDelivers"
                    style="width: 100%; height: 100%"
                  ></canvas>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="close">
            {{ $t('generic.cancel') }}
          </v-btn>
          <v-btn flat @click="download" v-if="dButton" color="primary">
            {{ $t('generic.download') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Chart from 'chart.js'
import jsPDF from 'jspdf'
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'stats', 'filters'],
  data: () => ({
    delivers: [],
    data: {},
    deliverChar: null,
    textNoInfo: '',
    dButton: false,
    colorsStd: [
      'rgb(146,43,33)',
      'rgb(203, 67, 53)',
      'rgb(118,68,138)',
      'rgb(155, 89, 182)',
      'rgb(31,97,141)',
      'rgb(40,116,166)',
      'rgb(20,143,119)',
      'rgb(17,122,101)',
      'rgb(30,132,73)',
      'rgb(35,155,86)',
      'rgb(183,149,11)',
      'rgb(185,119,14)',
      'rgb(175,96,26)',
      'rgb(160,64,0)',
      'rgb(247,187,87)',
    ],
    colorsColl: [
      'rgb(21, 67, 96)',
      'rgb(27, 79, 114)',
      'rgb(23, 32, 42)',
      'rgb(27, 38, 49)',
      'rgb(66, 73, 73)',
      'rgb(77, 86, 86)',
      'rgb(98, 101, 103)',
      'rgb(123, 125, 125)',
    ],
  }),
  watch: {
    value() {
      let vm = this
      let a = []
      let number = 0
      if (this.stats.studentCount) {
        if (this.stats.levelAccessCountList) {
          for (let a1 = 0; a1 < this.stats.levelAccessCountList.length; a1++) {
            a[number] = []
            a[number].num = this.stats.levelAccessCountList[a1].count
            a[number].typeDeliver = {}
            a[number].typeDeliver.id = 6
            a[number].typeDeliver.type =
              this.stats.levelAccessCountList[a1].label
            number++
          }
        } else {
          a[number] = []
          a[number].num = this.stats.studentCount
          a[number].typeDeliver = {}
          a[number].typeDeliver.id = 1
          a[number].typeDeliver.type = 'Alumnos'
          number++
        }
      }
      if (this.stats.collaboratorCount) {
        if (this.stats.roleAccessCountList) {
          for (let a1 = 0; a1 < this.stats.roleAccessCountList.length; a1++) {
            a[number] = []
            a[number].num = this.stats.roleAccessCountList[a1].count
            a[number].typeDeliver = {}
            a[number].typeDeliver.id = 7
            a[number].typeDeliver.type =
              this.stats.roleAccessCountList[a1].label
            number++
          }
        } else {
          a[number] = []
          a[number].num = this.stats.collaboratorCount
          a[number].typeDeliver = {}
          a[number].typeDeliver.id = 2
          a[number].typeDeliver.type = 'Colaboradores'
          number++
        }
      }
      if (this.stats.parentCount) {
        a[number] = []
        a[number].num = this.stats.parentCount
        a[number].typeDeliver = {}
        a[number].typeDeliver.id = 3
        a[number].typeDeliver.type = 'Tutores'
        number++
      }
      if (this.stats.visitCount) {
        a[number] = []
        a[number].num = this.stats.visitCount
        a[number].typeDeliver = {}
        a[number].typeDeliver.id = 4
        a[number].typeDeliver.type = 'Visitantes'
        number++
      }
      vm.delivers = a

      if (vm.deliverChar == null) {
        let ctx = document.getElementById('canvaStdByDelivers').getContext('2d')
        ctx.clearRect(0, 0, ctx.canvas.width + 100, ctx.canvas.height + 100)
        ctx.webkitImageSmoothingEnabled = false
        ctx.mozImageSmoothingEnabled = false
        ctx.imageSmoothingEnabled = false
        vm.deliverChar = new Chart(ctx, {
          type: 'bar',
          data: vm.charDataDeliver,
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index]
                },
              },
            },
            scales: {
              yAxes: [
                {
                  display: true,
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          },
        })
        vm.dButton = vm.delivers.length == 0 ? false : true
      } else {
        if (vm.delivers.length == 0) {
          vm.textNoInfo = 'No hay entregas en este periodo'
          vm.deliverChar.data.labels = new Array()
          vm.deliverChar.data.datasets = new Array()
          vm.dButton = false
          vm.deliverChar.update()
        } else {
          let charDataDeliver = vm.charDataDeliver
          vm.deliverChar.data.labels = charDataDeliver.labels
          vm.deliverChar.data.datasets = charDataDeliver.datasets
          vm.dButton = true
          vm.deliverChar.update()
        }
      }
    },
  },
  computed: {
    ...mapGetters(['getBranch']),

    charDataDeliver() {
      let vm = this
      let dataInDataset = []
      let labels = []
      let background = []
      var cStd = 0
      var cColl = 0
      for (const [index, item] of vm.delivers.entries()) {
        dataInDataset.push(item.num)
        if (item.typeDeliver) {
          switch (item.typeDeliver.id) {
            case 1:
              background.push('rgb(241,196,15)')
              labels.push(
                this.$t('reports.check_in_and_check_out_report.students') +
                  ': ' +
                  item.num
              )
              break
            case 2:
              background.push('rgb(34,93,107)')
              labels.push(
                this.$t('reports.check_in_and_check_out_report.collaborators') +
                  ': ' +
                  item.num
              )
              break
            case 3:
              background.push('rgb(11,83,69)')
              labels.push(
                this.$t('reports.check_in_and_check_out_report.tutors') +
                  ': ' +
                  item.num
              )
              break
            case 4:
              background.push('rgb(135,152,90)')
              labels.push(
                this.$t('reports.check_in_and_check_out_report.visitors') +
                  ': ' +
                  item.num
              )
              break
            case 5:
              background.push('rgb(204,204,0)')
              labels.push('Registro de salida' + ': ' + item.num)
              break
            case 6:
              background.push(this.colorsStd[cStd])
              labels.push(item.typeDeliver.type + ': ' + item.num)
              cStd++
              if (this.colorsStd.length == cStd) {
                cStd = 0
              }
              break
            case 7:
              background.push(this.colorsColl[cColl])
              labels.push(item.typeDeliver.type + ': ' + item.num)
              cColl++
              if (this.colorsColl.length == cColl) {
                cColl = 0
              }
              break
          }
        } else {
          labels.push('Desconocido: ' + item.num)
        }
      }
      return {
        datasets: [
          {
            data: dataInDataset,
            backgroundColor: background,
          },
        ],
        labels: labels,
      }
    },
  },
  props: ['value', 'stats', 'body'],
  methods: {
    close() {
      this.textNoInfo = ''
      this.delivers = []
      this.data = {}
      this.dButton = false
      this.$emit('input', !this.value)
      this.$emit('onClosed', false)
    },
    download() {
      var canvas = document.getElementById('canvaStdByDelivers')
      //creates image
      var canvasImg = canvas.toDataURL('image/png')
      var type = 'Reporte de entradas y salidas'
      var headers = []
      let doc = new jsPDF('landscape')
      let branch = this.getBranch
      //   let fDate =
      //     this.body.dayB +
      //     "-" +
      //     this.body.monthB +
      //     "-" +
      //     this.body.yearB +
      //     " al " +
      //     this.body.dayE +
      //     "-" +
      //     this.body.monthE +
      //     "-" +
      //     this.body.yearE;
      var pdfName = type
      var header = function (data) {
        // doc.text(100,20,"Colegio " + branch.name, 55, 15);
        // doc.text(100,20,"Periodo: " +  55, 35);
        // var splitTitle = doc.splitTextToSize(branch.address, 400);
        // var y = 45;
        // for (var i in splitTitle) {
        //   doc.text(100,20,splitTitle[i], 55, y);
        //   y += 5;
        // }
        var img = new Image()

        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/png;base64, ' + branch.img
          img.onload = function () {
            doc.addImage(imgData, 'PNG', data.settings.margin.left, 10, 30, 30) //(imagen,formato,x-pos,y-pos, width,heigth)
          }
        }
        var width = doc.internal.pageSize.getWidth()
        var widthNoMargins = width - data.settings.margin.left
        var pos = (widthNoMargins - 170) / 2
        doc.addImage(
          canvasImg,
          'PNG',
          pos,
          60,
          canvas.width / 3,
          canvas.height / 3
        )
      }
      doc.autoTable({
        head: [headers],
        margin: {
          top: 120,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        didDrawPage: header,
      })

      doc
        .save(type + '.pdf', { returnPromise: true })
        .then((res) => {
          console.log(res)
          //   this.working.wLoading = false;
          //   this.toast.success = true;
        })
        .catch((err) => {
          console.log(err)
          //   this.working.wLoading = false;
          //   this.toast.failed = true;
        })
    },
  },
}
</script>

<style scoped></style>
